import actions from './actions'

const waitlist = {
  state: {
    myCancelWaitList: [],
    myFacilityParkingCancelWaitlistList: []
  },
  mutations: {
    setWaitList (state, data) {
      state.myCancelWaitList = data.myCancelWaitList.items
      state.myFacilityParkingCancelWaitlistList = data.myFacilityParkingCancelWaitlistList.items
    },
    deleteWaitList (state, id) {
      const index = state.myCancelWaitList.findIndex(c => c.id === id)
      state.myCancelWaitList.splice(index, 1)
    },
    deleteParkingWaitList (state, id) {
      const index = state.myFacilityParkingCancelWaitlistList.findIndex(c => c.id === id)
      state.myFacilityParkingCancelWaitlistList.splice(index, 1)
    }
  },
  actions
}

export default waitlist
